var _desc, _defs, _rect, _ellipse, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPolarisAttributes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250,
    height: 247,
    viewBox: "0 0 449 443",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Product attributes illustration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "A product box with connected metafield tags.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "boxFront",
    x1: 115,
    y1: 124,
    x2: 271,
    y2: 282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7C867"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D99A2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "boxSide",
    x1: 272,
    y1: 129,
    x2: 338,
    y2: 285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFB64B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B97619"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tagTeal",
    x1: 76,
    y1: 240,
    x2: 207,
    y2: 341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8ACACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FA2A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tagGreen",
    x1: 260,
    y1: 244,
    x2: 371,
    y2: 328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6D986"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CA858"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "softShadow",
    x: 24,
    y: 53,
    width: 382,
    height: 319,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 18
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.16 0 0 0 0 0.21 0 0 0 0 0.22 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 449,
    height: 443,
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 224.5,
    cy: 342,
    rx: 167.5,
    ry: 19,
    fill: "#E7E9EA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#softShadow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112 129.5 194.7 91h153.8L271 129.5H112Z",
    fill: "#F2B844"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112 129.5h159v159.8H112V129.5Z",
    fill: "url(#boxFront)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271 129.5 348.5 91v159.4L271 289.3V129.5Z",
    fill: "url(#boxSide)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.7 93.7h47.5l-77.6 38.4h-46.5l76.6-38.4Z",
    fill: "#F6CD75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.5 132.1h46.7v53.8h-46.7v-53.8Z",
    fill: "#C99136",
    opacity: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 186,
    width: 104,
    height: 66,
    rx: 7,
    fill: "white",
    opacity: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 204,
    width: 55,
    height: 8,
    rx: 4,
    fill: "#C1C9CB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 222,
    width: 38,
    height: 8,
    rx: 4,
    fill: "#C1C9CB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205,
    y: 221,
    width: 21,
    height: 21,
    rx: 2,
    fill: "#C5CDD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4 268.8c-12.8-14-33.7-8-37.4 6.8-3.9 15.6 13 27.1 28.7 18.4 17.8-9.9 37.6-16 58.2-17.7",
    fill: "none",
    stroke: "#3F4A4E",
    strokeWidth: 7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 250,
    width: 121,
    height: 77,
    rx: 9,
    transform: "rotate(21 90 250)",
    fill: "url(#tagTeal)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 282,
    r: 8,
    fill: "white",
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267 267.5h54",
    stroke: "#4B5960",
    strokeWidth: 9,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267 302.5h54",
    stroke: "#4B5960",
    strokeWidth: 9,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315,
    y: 244,
    width: 70,
    height: 39,
    rx: 19.5,
    fill: "url(#tagGreen)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315,
    y: 281,
    width: 70,
    height: 39,
    rx: 19.5,
    fill: "#E77B63"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 339,
    cy: 263.5,
    r: 7.5,
    fill: "white",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 339,
    cy: 300.5,
    r: 7.5,
    fill: "white",
    opacity: 0.9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolarisAttributes);
export default __webpack_public_path__ + "static/media/polaris-attributes.155d0a242b296d0ef94570a6c90b08f2.svg";
export { ForwardRef as ReactComponent };